import { RestClient } from "./restClient";
import { RealtimeClient } from "./RealtimeClient";

/**
 * Service for evacuation procedures and accountability.
 */
export class EvacuationService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Create a new evacuation procedure on the server.
	 * @param {Object} data - The procedure data to send in the request body
	 * @param {Function} callback - Callback function to handle the response (error, result)
	 */
	createProcedure(data, callback) {
		const url = `/evacuation-accountability-app/api/procedure`;
		const body = JSON.stringify(data);

		this._restClient.exec_post(url, body, callback);
	}
	// PUT /procedure/manual-accountability
	sendManualAccountability(data, callback) {
		const url = `/evacuation-accountability-app/api/procedure/manual-accountability`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}
	// PUT /procedure/generate-pdf
	generateProcedurePDF(data, callback) {
		const url = `/evacuation-accountability-app/api/procedure/generate-pdf`;
		const body = JSON.stringify(data);

		this._restClient.exec_put(url, body, callback);
	}

	// PUT /procedure/reset-timer
	resetProcedure(procedureId, callback) {
		const url = `/evacuation-accountability-app/api/procedure/reset-procedure`;
		const body = JSON.stringify({ procedureId });
		this._restClient.exec_put(url, body, callback);
	}
	checkProcedureStatus(callback) {
		const url = `/evacuation-accountability-app/api/procedure/check-procedure-status`;
		this._restClient.exec_get(url, callback);
	}
	subscribeProcedureUpdates(callback) {
		return this._rc.subscribe("evacuation-accountability-app", "/evacuation-procedure", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
	resetTimer(procedureId, callback) {
		const url = `/evacuation-accountability-app/api/procedure/reset-timer`;
		const body = JSON.stringify({ procedureId });
		this._restClient.exec_put(url, body, callback);
	}
}
